import { render } from "./DeansReport.vue?vue&type=template&id=309f0fcd"
import script from "./DeansReport.vue?vue&type=script&lang=js"
export * from "./DeansReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__